import type { TranslateDictionary } from './en.js';

export const It: TranslateDictionary = {
  'Start airplay': 'Avvia AirPlay',
  'Stop airplay': 'Ferma AirPlay',
  Audio: 'Audio',
  Captions: 'Sottotitoli',
  'Enable captions': 'Abilita sottotitoli',
  'Disable captions': 'Disabilita i sottotitoli',
  'Start casting': 'Avvia trasmissione',
  'Stop casting': 'Ferma trasmissione',
  'Enter fullscreen mode': 'Riproduci a schermo intero',
  'Exit fullscreen mode': 'Esci dalla modalità a schermo intero',
  Mute: 'Disattiva audio',
  Unmute: 'Riattiva audio',
  'Enter picture in picture mode': 'Attiva modalità Picture in Picture',
  'Exit picture in picture mode': 'Disattiva modalità Picture in Picture',
  Play: 'Riproduci',
  Pause: 'Pausa',
  'Playback rate': 'Velocità di riproduzione',
  'Playback rate {playbackRate}': 'Velocità di riproduzione {playbackRate}',
  Quality: 'Qualità',
  'Seek backward': 'Indietro',
  'Seek forward': 'Avanti',
  Settings: 'Impostazioni',
  Auto: 'Auto',
  'audio player': 'lettore audio',
  'video player': 'lettore video',
  volume: 'Volume',
  seek: 'Cerca',
  'closed captions': 'Sottotitoli',
  'current playback rate': 'velocità di riproduzione corrente',
  'playback time': 'tempo di riproduzione',
  'media loading': 'caricamento media',
  settings: 'Impostazioni',
  'audio tracks': 'tracce audio',
  quality: 'Qualità',
  play: 'Riproduci',
  pause: 'Pausa',
  mute: 'Disattiva audio',
  unmute: 'Riattiva audio',
  'chapter: {chapterName}': 'capitolo: {chapterName}',
  live: 'dal vivo',
  Off: 'Disattivato',
  'start airplay': 'avvia AirPlay',
  'stop airplay': 'ferma AirPlay',
  'start casting': 'avvia trasmissione',
  'stop casting': 'ferma trasmissione',
  'enter fullscreen mode': 'riproduci a schermo intero',
  'exit fullscreen mode': 'esci dalla modalità a schermo intero',
  'enter picture in picture mode': 'attiva modalità picture in picture',
  'exit picture in picture mode': 'disattiva modalità picture in picture',
  'seek to live': 'vai al live',
  'playing live': 'riproduzione dal vivo',
  'seek back {seekOffset} seconds': 'indietro {seekOffset} secondi',
  'seek forward {seekOffset} seconds': 'avanti {seekOffset} secondi',
  'Network Error': 'Errore di rete',
  'Decode Error': 'Errore di decodifica',
  'Source Not Supported': 'Sorgente non supportata',
  'Encryption Error': 'Errore di crittografia',
  'A network error caused the media download to fail.':
    'Un errore di rete ha causato il fallimento del download del media.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    "Un errore del media ha causato l'interruzione della riproduzione. Il media potrebbe essere corrotto o il tuo browser non supporta questo formato.",
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Si è verificato un errore non supportato. Il server o la rete hanno fallito, o il tuo browser non supporta questo formato.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Il media è crittografato e non ci sono chiavi per decrittarlo.',
};
